import { IDisciplineViewerList } from 'Data/interfaces/FederatedViewer/IDisciplineViewerList';
import { IFileData } from 'Data/interfaces/ListagemArquivos/IListFilesResponse';
import { buildFileDownloadUrl } from 'Utils/downloadUrl';

// A página federada é urn-centric: a identidade do modelo na sessão é o urn da
// Autodesk (`urn:${BucketFile.Urn}`), que só existe depois da conversão. O nosso
// viewer não depende dela — lê o .ifc pelo download stream. Para o IFC ainda não
// convertido, a sessão usa uma urn sintética derivada do identificador do arquivo,
// e assim nada mais na página precisa deixar de ser urn-centric.
export const IFC_URN_PREFIX = 'ifc:';

export const isIfcUrn = (urn: string): boolean => urn.startsWith(IFC_URN_PREFIX);

export const ifcUrnForFile = (file: IFileData): string =>
  `${IFC_URN_PREFIX}${file.Identifier?.ApiId || file.Identifier?.ItemId}`;

// urn da sessão para o arquivo: o da Autodesk quando existe, senão o sintético.
export const fileToUrn = (file: IFileData): string => (
  file.FileInfo?.BucketFile?.Urn
    ? `urn:${file.FileInfo.BucketFile.Urn}`
    : ifcUrnForFile(file)
);

// urn ativo → arquivo da lista federada (aceita os dois formatos de urn).
export const resolveUrnToFile = (
  urn: string,
  disciplines: IDisciplineViewerList[],
): IFileData | undefined => {
  const synthetic = isIfcUrn(urn);
  for (const discipline of disciplines) {
    const file = discipline.FilesList?.find((f) => (synthetic
      ? ifcUrnForFile(f) === urn
      : `urn:${f.FileInfo?.BucketFile?.Urn}` === urn));
    if (file) { return file; }
  }
  return undefined;
};

// Download stream (mesmo contrato do viewer single). `api` = Api do CANTEIRO;
// `itemsIds` = identificador do arquivo.
export const fileToUrl = (file: IFileData, constructionSiteId: number): string =>
  buildFileDownloadUrl({
    constructionSiteId,
    api: file.FileInfo.Api,
    fileApiId: file.Identifier.ApiId || file.Identifier.ItemId,
  });
